import { render, staticRenderFns } from "./SeatingAreas.vue?vue&type=template&id=840fd0d0"
import script from "./SeatingAreas.vue?vue&type=script&lang=js"
export * from "./SeatingAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports